import { render } from "./Three5Charts.vue?vue&type=template&id=bcc68a4a&scoped=true"
import script from "./Three5Charts.vue?vue&type=script&lang=js"
export * from "./Three5Charts.vue?vue&type=script&lang=js"

import "./Three5Charts.vue?vue&type=style&index=0&id=bcc68a4a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc68a4a"]])

export default __exports__